import { EmployeesInput } from 'domain/shared/employee';
import { CheckboxGroup, TextArea, TextInput } from 'framework/form';
import type { CreateEditFormSection } from 'framework/ViewTypes/contentLayout';
import { CANDIDATE_CHECK_OPTIONS } from '../../constants';

const FULL_WIDTH = { xs: 12, md: 12, xl: 12 };
const HALF_WIDTH = { xs: 12, md: 6, xl: 6 };
const TRHREE_QUARTERS_WIDTH = { xs: 12, md: 8, xl: 8 };

const fieldSx = {
  '& .floating-label-input, & .floating-label-baseInput, & .floating-label-dropdown': { mb: 0 },
};

export const getRecruitmentPoolSections = (): CreateEditFormSection[] => [
  {
    id: 'pool-information',
    fields: [
      {
        id: 'name',
        size: TRHREE_QUARTERS_WIDTH,
        sx: fieldSx,
        content: <TextInput source="name" label="Recruitment pool name" />,
      },
      {
        id: 'recruitingTeam',
        size: TRHREE_QUARTERS_WIDTH,
        sx: fieldSx,
        content: (
          <EmployeesInput
            defaultFilter={{
              'specification:isRecruiter': {
                eq: true,
              },
            }}
            source="recruitingTeam"
            label="Recruitment team"
          />
        ),
      },
      {
        id: 'requiredCandidateCheckTypes',
        size: HALF_WIDTH,
        sx: fieldSx,
        content: (
          <CheckboxGroup
            source="requiredCandidateCheckTypes"
            label="Required candidate checks"
            options={CANDIDATE_CHECK_OPTIONS}
          />
        ),
      },
      {
        id: 'description',
        size: FULL_WIDTH,
        sx: fieldSx,
        content: <TextArea source="description" label="Description" rows={6} />,
      },
    ],
  },
];
